import { MousePointer2, Hand, Square, Minus, DoorOpen, Bot, Zap, Eraser, Play } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useDungeonEditorStore, type ToolType } from '@/store/dungeonEditorStore';

interface ToolButton {
  id: ToolType;
  icon: React.ComponentType<{ size?: number; className?: string }>;
  label: string;
}

const TOOLS: ToolButton[] = [
  { id: 'select', icon: MousePointer2, label: 'Select (V)' },
  { id: 'hand', icon: Hand, label: 'Hand (H)' },
  { id: 'room', icon: Square, label: 'Draw Room (R)' },
  { id: 'corridor', icon: Minus, label: 'Corridor (C)' },
  { id: 'door', icon: DoorOpen, label: 'Door (D)' },
  { id: 'entity', icon: Bot, label: 'Entity (E)' },
  { id: 'trigger', icon: Zap, label: 'Trigger (T)' },
  { id: 'erase', icon: Eraser, label: 'Erase (X)' },
];

export function EditorToolbar() {
  const selectedTool = useDungeonEditorStore((s) => s.selectedTool);
  const setTool = useDungeonEditorStore((s) => s.setTool);
  const setPlaytesting = useDungeonEditorStore((s) => s.setPlaytesting);

  return (
    <div className="flex flex-col items-center w-12 bg-gray-900 border-r border-gray-700 py-2 gap-1">
      {TOOLS.map(({ id, icon: Icon, label }) => (
        <div key={id} className="relative group">
          <button
            onClick={() => setTool(id)}
            className={cn(
              'w-9 h-9 flex items-center justify-center rounded transition-colors',
              'text-gray-400 hover:text-white hover:bg-gray-700',
              selectedTool === id && 'bg-blue-600 text-white hover:bg-blue-500'
            )}
          >
            <Icon size={18} />
          </button>
          <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 px-2 py-1 rounded bg-gray-800 text-white text-xs whitespace-nowrap opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity shadow-lg border border-gray-700 z-50">
            {label}
          </div>
        </div>
      ))}

      {/* Spacer */}
      <div className="flex-1" />

      {/* Playtest button */}
      <button
        title="Playtest"
        onClick={() => setPlaytesting(true)}
        className="w-9 h-9 flex items-center justify-center rounded transition-colors text-gray-400 hover:text-white hover:bg-green-700"
      >
        <Play size={18} />
      </button>
    </div>
  );
}
